import { Component } from '@angular/core';

@Component({
  selector: 'iris-card',
  styleUrls: ['./iris-card.component.css'],
  templateUrl: './iris-card.component.html',
  standalone: false,
})
export class IrisCardComponent {}
